@if (quote) {
  <div class="d-flex justify-content-sm-end mb-2">
    <a class="no-select" (click)="tradeService.toggleSpread()">
      {{ 'trade.create.quote.spread-toggle.' + (tradeService.displaySpread$ | async) | transloco }}
    </a>
  </div>
}

<div class="d-sm-flex justify-content-between align-items-center" [class.detract-attention]="!quote" data-zid="quote-container">
  <div>{{ 'trade.create.quote.spread-label.' + (tradeService.displaySpread$ | async) | transloco }}</div>
  @if (quote) {
    <div>
      @if (tradeService.displaySpread$ | async) {
        <span class="font-size-3 font-bold" data-zid="quote-spread"> {{ quote.bid | number: quoteFormat }} € / </span>
        <span class="font-size-3 font-bold quoteindicator-variant2" zeroBlink [val]="quote.ask">
          {{ quote.ask | number: quoteFormat }} €
        </span>
      } @else {
        @if (direction === 'buy') {
          <span class="font-size-3 font-bold quoteindicator-variant2" zeroBlink [val]="quote.ask" data-zid="quote-buy">
            {{ quote.ask | number: quoteFormat }} €
          </span>
        }
        @if (direction === 'sell') {
          <span class="font-size-3 font-bold quoteindicator-variant2" zeroBlink [val]="quote.bid" data-zid="quote-sell">
            {{ quote.bid | number: quoteFormat }} €
          </span>
        }
      }
    </div>
  } @else {
    <div>&mdash;</div>
  }
</div>
<hr />
